import * as types from "../constants/actionTypes";
import {
  getPlaceHoldersApi,
  getAnalyticsPlaceHoldersApi
} from "../api/placeHolders";

import { generateAsyncAction } from "./generateAsyncAction";

export const getPlaceHolders = request => async (dispatch, getState) => {
  dispatch({ type: types.GET_PLACE_HOLDERS_REQUEST });
  const { selectedOption } = getState();
  request.selectedOption = selectedOption;
  const getPlaceHoldersAction = await generateAsyncAction({
    onFailAction: placeHoldersFailed,
    onSuccessAction: placeHoldersSuccess,
    asyncApiMethod: getPlaceHoldersApi,
    request
  });
  return dispatch(getPlaceHoldersAction);
};

const placeHoldersSuccess = ({ payload, request }) => dispatch => {
  dispatch({
    type: types.GET_PLACE_HOLDERS_SUCCESS,
    payload: { ...request, content: payload }
  });
};

const placeHoldersFailed = ({ message, title }) => ({
  type: types.GET_PLACE_HOLDERS_FAILED,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const getAnalyticsPlaceHolders = request => async dispatch => {
  dispatch({ type: types.GET_ANALYTICS_PLACE_HOLDERS_REQUEST });
  const getPlaceHoldersAction = await generateAsyncAction({
    onFailAction: analyticsPlaceHoldersFailed,
    onSuccessAction: analyticsPlaceHoldersSuccess,
    asyncApiMethod: getAnalyticsPlaceHoldersApi,
    request
  });
  return dispatch(getPlaceHoldersAction);
};

const analyticsPlaceHoldersSuccess = ({ payload, request }) => dispatch => {
  dispatch({
    type: types.GET_ANALYTICS_PLACE_HOLDERS_SUCCESS,
    payload: { phase: request.Phase, content: payload }
  });
};

const analyticsPlaceHoldersFailed = ({ message, title }) => ({
  type: types.GET_ANALYTICS_PLACE_HOLDERS_FAILED,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const clearAnalyticsPlaceHolders = () => dispatch => {
  dispatch({
    type: types.CLEAR_ANALYTICS_PLACE_HOLDERS
  });
};



// WEBPACK FOOTER //
// ./src/actions/placeHoldersActions.js